import React, { useState } from 'react'
import PropTypes from 'prop-types'

import ImageVersioningContext from '../context/ImageVersioningContext'

import useInterval from '../hooks/useInterval'

import { primaryNetworkConnectedWithCallbacks } from '../utils/networkConnected'

const ONE_HOUR = 3600000
const DEFAULT_VERSION = 'default'

const ImageVersioning = ({ children }) => {
  const [version, setVersion] = useState(Date?.now())

  const getUrlWithVersion = (url) => {
    return `${url}?v=${version}`
  }

  const setImageVersion = (version) => {
    primaryNetworkConnectedWithCallbacks(
      () => setVersion(version || DEFAULT_VERSION),
      () => {},
    )
  }

  useInterval(() => {
    setImageVersion(Date.now())
  }, [ONE_HOUR])

  return (
    <ImageVersioningContext.Provider
      value={{
        version,
        getUrlWithVersion,
        setImageVersion,
      }}
    >
      {children}
    </ImageVersioningContext.Provider>
  )
}

ImageVersioning.propTypes = {
  children: PropTypes.element.isRequired,
}

export default ImageVersioning
